/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoContattoCreateDTO
 */
export interface AssistitoContattoCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoContattoCreateDTO
     */
    cognome?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoContattoCreateDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoContattoCreateDTO
     */
    tipoContattoId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoContattoCreateDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoContattoCreateDTO
     */
    telefono?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoContattoCreateDTO
     */
    cellulare?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoContattoCreateDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the AssistitoContattoCreateDTO interface.
 */
export function instanceOfAssistitoContattoCreateDTO(value: object): value is AssistitoContattoCreateDTO {
    return true;
}

export function AssistitoContattoCreateDTOFromJSON(json: any): AssistitoContattoCreateDTO {
    return AssistitoContattoCreateDTOFromJSONTyped(json, false);
}

export function AssistitoContattoCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoContattoCreateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'cognome': json['cognome'] == null ? undefined : json['cognome'],
        'nome': json['nome'] == null ? undefined : json['nome'],
        'tipoContattoId': json['tipoContattoId'] == null ? undefined : json['tipoContattoId'],
        'email': json['email'] == null ? undefined : json['email'],
        'telefono': json['telefono'] == null ? undefined : json['telefono'],
        'cellulare': json['cellulare'] == null ? undefined : json['cellulare'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function AssistitoContattoCreateDTOToJSON(value?: AssistitoContattoCreateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'cognome': value['cognome'],
        'nome': value['nome'],
        'tipoContattoId': value['tipoContattoId'],
        'email': value['email'],
        'telefono': value['telefono'],
        'cellulare': value['cellulare'],
        'note': value['note'],
    };
}

